import { render, staticRenderFns } from "./AutocompleteDepartment.vue?vue&type=template&id=8b63527a"
import script from "./AutocompleteDepartment.vue?vue&type=script&lang=js"
export * from "./AutocompleteDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports